import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20938991")

_pushScopeId("data-v-20938991")
const _hoisted_1 = { class: "nav-block" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Solutions")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Products")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Company")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  href: "mailto: service@ee-comm.com",
  class: "emailto"
}, [
  /*#__PURE__*/_createVNode("p", null, "service@ee-comm.com")
], -1)
const _hoisted_8 = { class: "copyright-block" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "left" }, [
  /*#__PURE__*/_createVNode("div", { class: "logo" }),
  /*#__PURE__*/_createVNode("div", { class: "readme" }, [
    /*#__PURE__*/_createVNode("p", null, "The system that can completely prevent VAT fraud.")
  ])
], -1)
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "copyright" }, " ＠2021 EECOMM All Rights Reserved ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Privacy Policy")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLine = _resolveComponent("GridLine")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("footer", null, [
    _createVNode(_component_GridLine, { class: "hide1 hide2 hide3 hide5" }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("nav", null, [
          _createVNode(_component_router_link, { to: "/solutions" }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/products" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/company" }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/contact" }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _hoisted_7
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "contact-us"
          }),
          _hoisted_12,
          _createVNode(_component_router_link, {
            class: "privacy-policy",
            to: "/privacy-policy"
          }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
})